const getFirebaseKey = () => {
  return {
    apiKey: "AIzaSyCFJ4qTTX58_LAiEvZGTJ_Xhugq-JO43WI",
    authDomain: "todo-react-app-22896.firebaseapp.com",
    databaseURL: "https://todo-react-app-22896.firebaseio.com",
    projectId: "todo-react-app-22896",
    storageBucket: "todo-react-app-22896.appspot.com",
    messagingSenderId: "151158693183",
    appId: "1:151158693183:web:c32e3d280a120f53e2078a",
  };
};

export default {
  getFirebaseKey,
};
